import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfp-financial-health-chart',
  templateUrl: './financial-health-chart.component.html',
  styleUrls: ['./financial-health-chart.component.scss']
})
export class FinancialHealthChartComponent {
  @Input() financialSituationTitle = '';
  @Input() deathTitle = '';
  @Input() educationTitle = '';
  @Input() savingTitle = '';
  @Input() retirementTitle = '';
  @Input() forceDesktopStyle = false;
}
